// Per-type action sets for the desktop case tables. Each set has the same
// shape; a missing action means the type does not support it (no ★ column,
// no re-check button, …). Payloads match what the classic cards send.
import * as astika from "./caseActions";

const JSON_OPTIONS = {
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
};

// Delete + note, which every type has.
const entityActions = (base, { noteId = (id) => String(id) } = {}) => ({
  deleteCase: (api, id) =>
    api.patch(base, JSON.stringify({ key: String(id) }), JSON_OPTIONS),
  saveNote: (api, id, note) =>
    api.post(`${base}/note`, JSON.stringify({ id: noteId(id), note }), JSON_OPTIONS),
});

export const ASTIKA_ACTIONS = {
  setFav: astika.setFav,
  recheck: astika.recheck,
  deleteCase: astika.deleteCase,
  saveNote: astika.saveNote,
  startBulkCheckAll: astika.startBulkCheckAll,
  checkCategory: "solon_check",
};

export const ADJ_ACTIONS = {
  ...entityActions("/adjustice"),
  setFav: (api, id, fav) =>
    api.post("/adjustice/fav", JSON.stringify({ id, fav }), JSON_OPTIONS),
  recheck: (api, id) =>
    api.post("/adjustice/check", JSON.stringify({ id: String(id) }), JSON_OPTIONS),
  checkCategory: "adj_check",
};

// The classic OutSolon card sends the numeric id for notes.
export const OUT_ACTIONS = entityActions("/outsolon", { noteId: (id) => id });

export const EAUCTION_ACTIONS = entityActions("/eauctions");

export const POINIKA_ACTIONS = entityActions("/poinpin");
